var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"detail"},[_c('div',{staticClass:"list"},[_c('hight-light',{attrs:{"text":_vm.name,"bg-text":_vm.name,"is-bg":true}}),_c('img',{attrs:{"src":_vm.image,"alt":""}}),_c('div',{staticClass:"content-list"},[_vm._v(_vm._s(_vm.content))])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }